import img1 from "../src/img/chicken noodles.webp";
import img2 from "../src/img/egg noodles 12.jpg";
import img3 from "../src/img/chicken-fried-rice-.jpg";
import img4 from "../src/img/egg rice 1.webp";


const Noodlesdata ={
    cardData : [
  
             {
                id: 1,
                imgSrc:img1 ,
                title: 'Chicken Noodles',
                cont : 'Chicken Noodles ,Egg Nooodles, Chicken Rice, ,Egg Rice',
                 link : './Briyani',
                 rs : '160'
             },
             {
                 id: 2,
                 imgSrc:img2 ,
                 title: 'Egg Noodles',
                 cont : 'Chicken Noodles ,Egg Nooodles, Chicken Rice, ,Egg Rice',
                 rs : '120'
              } ,
              {
                 id: 3,
                 imgSrc:img3 ,
                 title: 'Chicken Rice',
                 cont : 'Chicken Noodles ,Egg Nooodles, Chicken Rice, ,Egg Rice',
                 rs : '160'
               } ,
              {
                 id: 4,
                 imgSrc:img4,
                 title: 'Egg Rice',
                 cont : 'Chicken Noodles ,Egg Nooodles, Chicken Rice, ,Egg Rice',
                 rs : '120'
              },     
     ]
 };
 
 export default Noodlesdata;